
/*
███████╗███╗   ███╗███████╗               █████╗ ██████╗ ██████╗
██╔════╝████╗ ████║██╔════╝              ██╔══██╗██╔══██╗██╔══██╗
███████╗██╔████╔██║███████╗    █████╗    ███████║██████╔╝██████╔╝
╚════██║██║╚██╔╝██║╚════██║    ╚════╝    ██╔══██║██╔═══╝ ██╔═══╝
███████║██║ ╚═╝ ██║███████║              ██║  ██║██║     ██║
╚══════╝╚═╝     ╚═╝╚══════╝              ╚═╝  ╚═╝╚═╝     ╚═╝
*/

import Vue from 'vue'
import Bootstrap from './Bootstrap.vue'
import router from './router'
import store from './store'
import mixins from './mixins'
import viewports from './config/viewports'
import scrollto from './config/scrollto'
import ZiadUI from 'ziad-ui'
import VueScrollTo from 'vue-scrollto'
import VueViewports from 'vue-viewports'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'ziad-ui/dist/ziad-ui.css'
import './registerServiceWorker'

// --------------------------------------------------------------------------

// Import and mounted components customns
import allComponents from './components'

for (var item of allComponents) {
    Vue.component(item.name, item.component)
}

// --------------------------------------------------------------------------

// Icons

require('./icons.js')

Vue.component('font-awesome-icon', FontAwesomeIcon)

// --------------------------------------------------------------------------

// ViewPort Configs
Vue.use(VueViewports, viewports)

// --------------------------------------------------------------------------

// Event Hub
Vue.prototype.$eventHub = new Vue()

// --------------------------------------------------------------------------

// Production
Vue.config.productionTip = process.env.NODE_ENV === 'production'


// Error handler
if (process.env.NODE_ENV === 'production') {
    Vue.config.errorHandler = () => null
}

// --------------------------------------------------------------------------

// Scroll
Vue.use(VueScrollTo, scrollto)

// --------------------------------------------------------------------------

// Implement Ziad UI
Vue.use(ZiadUI)

// --------------------------------------------------------------------------

// Mixins
Vue.mixin(mixins)

// --------------------------------------------------------------------------

new Vue({
    router,
    store,
    render: h => h(Bootstrap)
}).$mount('#app')

// --------------------------------------------------------------------------

/**
 * Responsável por verificar se a conexão está ativa ou inativa do usuário
 */
function updateConnectionStatus () {
    store.state.onLine = navigator.onLine
}

window.addEventListener('online', updateConnectionStatus)
window.addEventListener('offline', updateConnectionStatus)

// --------------------------------------------------------------------------
